export const AD_AUTHORITY_URL = 'https://login.microsoftonline.com/';
export const SELECT_LOCATION_MESSAGE = 'error';
